module.exports = __webpack_public_path__ + "static/logo-8ec1dbd4799bcbafc0b77ec16c1bc5fc.svg";